import React from 'react';
import { useAlerts } from '@/contexts/AlertContext';
import { Bell, BellOff, Wifi, WifiOff } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

export default function NotificationStatus() {
  const { sseConnected, pushPermission, subscribePush, unsubscribePush } = useAlerts();

  const handleTogglePush = async () => {
    if (pushPermission === 'granted') {
      await unsubscribePush();
      toast.info('Notifiche push disabilitate');
    } else {
      const ok = await subscribePush();
      if (ok) {
        toast.success('Notifiche push abilitate!');
      } else if (pushPermission === 'denied') {
        toast.error('Permesso notifiche negato dal browser. Controlla le impostazioni del sito.');
      }
    }
  };

  const pushSupported = 'PushManager' in window;

  return (
    <div className="flex items-center gap-3" data-testid="notification-status">
      <div className="flex items-center gap-1.5" data-testid="sse-status">
        {sseConnected ? (
          <Wifi className="w-3.5 h-3.5 text-emerald-500" />
        ) : (
          <WifiOff className="w-3.5 h-3.5 text-slate-400" />
        )}
        <span className={`text-xs ${sseConnected ? 'text-emerald-600' : 'text-slate-400'}`}>
          {sseConnected ? 'Live' : 'Polling'}
        </span>
      </div>

      {pushSupported && (
        <Button
          variant="ghost"
          size="sm"
          className="h-7 px-2 text-xs gap-1.5"
          onClick={handleTogglePush}
          data-testid="push-toggle-btn"
        >
          {pushPermission === 'granted' ? (
            <>
              <Bell className="w-3.5 h-3.5 text-emerald-500" />
              <span className="text-emerald-600">Push ON</span>
            </>
          ) : (
            <>
              <BellOff className="w-3.5 h-3.5 text-slate-400" />
              <span className="text-slate-500">Push OFF</span>
            </>
          )}
        </Button>
      )}
    </div>
  );
}
